var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdvancedMonitoringOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-27 -517) translate(0 504)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", null), /*#__PURE__*/React.createElement("path", {
    fill: "#424A56",
    fillRule: "nonzero",
    d: "M7.01 20.01C7.01 21.11 7.9 22 9 22s1.99-.89 1.99-1.99H7.01zM9 5c2.76 0 5 2.24 5 5v7H4v-7c0-2.76 2.24-5 5-5zM9 .5c-.83 0-1.5.67-1.5 1.5v1.17C4.36 3.85 2 6.65 2 10v6l-2 2v1h18v-1l-2-2v-6c0-3.35-2.36-6.15-5.5-6.83V2c0-.83-.67-1.5-1.5-1.5zM8 7h2v4H8V7zm0 6h2v2H8v-2z",
    transform: "translate(27 13)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvancedMonitoringOutline);
export default __webpack_public_path__ + "static/media/advanced-monitoring-outline.0ace216390ec0b764599546784b7936c.svg";
export { ForwardRef as ReactComponent };